module.exports = __webpack_public_path__ + "img/mother-of-thousands-2.b66977e6.jpg";